import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import LoaderHelper from "../../../Services/Loading/LoaderHelper";
import AuthService from "../../../Services/ApiServices/AuthService";
import { alertErrorMessage } from "../../../Services/CustomAlertModel";
import { ApiConfig } from "../../../Services/ApiServices/AuthAction/ApiConfig";
import Sidebar from "../../CoustamComponent/Sidebar";
import DataTable from "react-data-table-component";


const SupportList = () => {
  const [data, setData] = useState("");

  useEffect(() => {
    const handleMyTicket = async () => {
      LoaderHelper.loaderStatus(true);
      try {
        const result = await AuthService.getTicketList();
        if (result.success) {
          LoaderHelper.loaderStatus(false);
          setData(result.data.reverse());
        } else {
          alertErrorMessage(result.message);
        }
      } catch (error) {
        alertErrorMessage(error.message);
      } finally {
        LoaderHelper.loaderStatus(false);
      }
    };
    handleMyTicket();
  }, [])

  const imageFormatter = (row) => {
    return (
      <img style={{ width: "40%", height: "auto" }} className="table-img" src={ApiConfig?.url + row?.images[0]} alt="img" />
    );
  };

  const columns = [
    { name: "Date", selector: row => moment(row?.createdAt).format("Do MMMM YYYY"), wrap: true, grow: .5 },
    { name: "Name", selector: row => row?.name, grow: .5, wrap: true, },
    { name: <div style={{ whiteSpace: 'revert' }}>Ticket Number</div>, selector: row => row?.ticket_number, grow: .5, wrap: true, },
    { name: <div style={{ whiteSpace: 'revert' }}>Mobile Number</div>, selector: row => row?.mobile_number, grow: .5, wrap: true },
    { name: "Email Id", wrap: true, selector: row => row?.email, grow: .5 },
    { name: <div style={{ whiteSpace: 'revert' }}>Title</div>, wrap: true, selector: row => row?.title, grow: .5 },
    { name: "Snap Shot", selector: imageFormatter, grow: .5, wrap: true, },
    { name: "Admin Reply", selector: row => row?.admin_reply, grow: .5, wrap: true, },
    { name: "Description", selector: row => row?.description, grow: .5, wrap: true, },
    { name: "Status", selector: row => row?.status, grow: .5, wrap: true, },
  ];


  return (

    <div class="wrapper dashboard_page" >
      <div class=" page-body d-flex align-items-stretch">
        <div class="page-content">
          <Sidebar />
          <div className="page_wrapper" >
            <div className="container " >
              <div className="row g-3" >
                <div className="col-lg-12" >
                  <div className="card  " >
                    <div className="card-body" >
                      <h4>
                        <Link to="/support-messages" className=" text-warning  me-3 ps-0">
                          <small> <i class="ri-arrow-left-line  "></i></small>
                        </Link>  <strong>Help Center</strong>
                      </h4>
                      <div className="table_data" >
                        <div className="table-responsive" >
                          <div className="container">
                            <div className="tab-content custom-tab-content p-0">
                              <DataTable pagination columns={columns} data={data} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportList;
